import { render, staticRenderFns } from "./Knowledge_check_detail_wrap.vue?vue&type=template&id=6bac5644"
import script from "./Knowledge_check_detail_wrap.vue?vue&type=script&lang=js"
export * from "./Knowledge_check_detail_wrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports